<template>
  <div class="c-globalNav__wrap">
    <div class="c-globalNav__user">
      <div class="c-globalNav__user__icon">
        <a href="/1825/mypage" class="">
          <img src="/assets/img/header/icon-avatar.png" alt="" />
        </a>
      </div>
      <p class="c-globalNav__user__text">{{ roomNo }}号室</p>
    </div>
    <ul class="c-globalNav__nav">
      <li
        class="c-globalNav__nav__item"
        v-for="(item, i) in items"
        :key="`globalNavitem-${i}`"
      >
        <router-link class="c-globalNav__nav__item__title" :to="item.routerTo">
          {{ item.text }}
        </router-link>
      </li>
      <li class="c-globalNav__nav__item">
        <a class="c-globalNav__nav__item__title" @click="logOut()"
          >ログアウト</a
        >
      </li>
    </ul>
    <div class="c-globalNav__banner">
      <div
        class="c-globalNav__banner__item"
        v-for="banner in bannerData"
        :key="banner.img"
      >
        <a :href="banner.url" target="_blank"><img :src="banner.path"/></a>
      </div>
    </div>
    <div class="c-globalNav__nav__calendarWrap">
      <Calender />
    </div>
  </div>
</template>

<script>
import Calender from "@/components/Calender.vue";

export default {
  name: "GlobalNav",
  components: {
    Calender,
  },
  props: {
    type: String,
    roomNo: String,
  },
  data() {
    return {
      bannerData: [],
    };
  },
  async mounted() {
    this.bannerData = await this.getBannerJson();
  },
  methods: {
    async getBannerJson() {
      const res = await fetch(
        `${process.env.VUE_APP_BASE_URL}/assets/custom/banner/setting.json`,
      );
      const json = await res.json();
      const bannerShowCategory = json.bannerShowCategory;

      const mansion = this.currentUser.mansion;
      const dai_bunrui = mansion.dai_bunrui;
      const chu_bunrui = mansion.chu_bunrui;
      const mc_code = mansion._id;

      const showBanners = [];
      for (const category in bannerShowCategory) {
        if (category === dai_bunrui) {
          showBanners.push(bannerShowCategory[category]);
        }
        if (category === `${dai_bunrui}/${chu_bunrui}`) {
          showBanners.push(bannerShowCategory[category]);
        }
        if (category === `${dai_bunrui}/${chu_bunrui}/${mc_code}`) {
          showBanners.push(bannerShowCategory[category]);
        }
      }

      let joinShowBanners = [];
      showBanners.map(banners => {
        banners.map(_ => {
          joinShowBanners.push(_);
        });
      });

      const bannerPaths = joinShowBanners.map(banner => {
        return {
          path: `${process.env.VUE_APP_BASE_URL}/assets/custom/banner/img/${banner.img}`,
          url: banner.url,
        };
      });

      return bannerPaths;
    },
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
  },
  computed: {
    items() {
      const itemsTemp = {
        default: [
          {
            routerTo: {
              name: "top",
              params: { mc_code: this.mcCode },
            },
            text: "トップ",
          },
          {
            routerTo: {
              name: "mypage",
              params: { mc_code: this.mcCode },
            },
            text: "ユーザー情報",
          },
          {
            routerTo: {
              name: "information-1",
              params: { mc_code: this.mcCode },
            },
            text: "お知らせ",
          },
          {
            routerTo: {
              name: "allocation-index",
              params: { mc_code: this.mcCode },
            },
            text: "駐車場等お申し込み",
          },
          {
            routerTo: {
              name: "mc-event-index",
              params: { mc_code: this.mcCode },
            },
            text: "イベント",
          },
          {
            routerTo: {
              name: "archive-list",
              params: { mc_code: this.mcCode, category: 1 },
            },
            text: "ご入居までのスケジュール",
          },
          {
            routerTo: {
              name: "archive-list",
              params: { mc_code: this.mcCode, category: 2 },
            },
            text: "ご入居に関する書類",
          },
          {
            routerTo: {
              name: "qa",
              params: { mc_code: this.mcCode },
            },
            text: "Q&A",
          },
        ],
        contractor: [
          {
            routerTo: {
              name: "top",
              params: { mc_code: this.mcCode },
            },
            text: "トップ",
          },
          {
            routerTo: {
              name: "mypage",
              params: { mc_code: this.mcCode },
            },
            text: "ユーザー情報",
          },
          {
            routerTo: {
              name: "information-1",
              params: { mc_code: this.mcCode },
            },
            text: "お知らせ",
          },
          {
            routerTo: {
              name: "allocation-index",
              params: { mc_code: this.mcCode },
            },
            text: "駐車場等お申し込み",
          },
          {
            routerTo: {
              name: "mc-event-index",
              params: { mc_code: this.mcCode },
            },
            text: "イベント",
          },
          {
            routerTo: {
              name: "archive-list",
              params: { mc_code: this.mcCode, category: 1 },
            },
            text: "ご入居までのスケジュール",
          },
          {
            routerTo: {
              name: "archive-list",
              params: { mc_code: this.mcCode, category: 2 },
            },
            text: "ご入居に関する書類",
          },
          {
            routerTo: {
              name: "qa",
              params: { mc_code: this.mcCode },
            },
            text: "Q&A",
          },
        ],
      };
      if (this.type === "contractor") {
        return itemsTemp["contractor"];
      } else {
        return itemsTemp["default"];
      }
    },
  },
};
</script>

<style></style>
